import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearAuth } from "../Redux/authSlice";
import { TiHome } from "react-icons/ti";
import { IoPerson } from "react-icons/io5";
import { BsChatDots } from "react-icons/bs";
import { AiOutlineLogout } from "react-icons/ai";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { TbReceiptRefund } from "react-icons/tb";
import { IoReceiptOutline } from "react-icons/io5";
import { PiReceiptBold } from "react-icons/pi";
import { RiChatFollowUpLine } from "react-icons/ri";
import Lottie from "lottie-react";
import inviterAnimation from '../assets/inviter.json'; // ton JSON Lottie
import DrawOutlineButton from "./DrawOutlineButton";
const Sidebar = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 840);
  const [relancesOpen, setRelancesOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const auth = useSelector((state) => state.auth); // Pour vérifier si l'utilisateur est connecté

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 840);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = (path) => {
    navigate(path);
    if (isMobile) document.body.classList.remove("overflow-hidden");
  };

  const handleLogout = () => {
    dispatch(clearAuth());
    navigate("/login");
  };

  const menuItems = [
    { label: "Dashboard", icon: TiHome, path: "/EspaceClient" },
    { label: "Clients", icon: IoPerson, path: "/EspaceClient/clients" },
    { label: "Devis", icon: IoReceiptOutline, path: "/EspaceClient/devis" },
    { label: "Factures", icon: PiReceiptBold, path: "/EspaceClient/factures" },
    { label: "Avoirs", icon: TbReceiptRefund, path: "/EspaceClient/avoirs" },
    { label: "Relancer", icon: RiChatFollowUpLine, path: "/EspaceClient/relances", hasSubMenu: true },
    { label: "Profil", icon: IoPerson, path: "/EspaceClient/profil" },
    { label: "Support", icon: BsChatDots, path: "/EspaceClient/support" },
  ];

  const relancesSubMenu = [
    { label: "Devis", path: "/EspaceClient/relances/devis", icon: IoReceiptOutline },
    { label: "Facture", path: "/EspaceClient/relances/factures", icon: PiReceiptBold },
  ];

  const isActiveMain = (item) => {
    if (item.hasSubMenu) return false;
    return location.pathname === item.path;
  };

  const isSubMenuActive = (sub) => location.pathname.startsWith(sub.path);

  return (
    <div className="relative">
      {!isMobile && (
        <div className="fixed top-0 left-0 flex flex-col h-screen bg-color1 text-color2 px-0 py-3 overflow-hidden scrollbar-thin scrollbar-thumb-black scrollbar-track-gray-900 rounded-r-lg border-r-2 border-color1/30">

          {/* Logo */}
          <div className="flex flex-col items-start cursor-pointer justify-start mb-2">
            <img
              src={require('../assets/logo.png')}
              alt="Logo Gestion Freelance"
              className="h-[60px] w-[200px] object-contain"
            />
          </div>

          {/* Menu principal */}
          <div className="flex-1 flex flex-col gap-1 overflow-y-auto">
            {menuItems.filter(item => item.label !== "Support").map(item => {
              const selected = isActiveMain(item);

              if (item.hasSubMenu) {
                const subSelected = relancesSubMenu.some(sub => isSubMenuActive(sub));
                if (subSelected && !relancesOpen) setRelancesOpen(true);

                return (
                  <div key={item.label}>
                    <button
                      onClick={() => setRelancesOpen(!relancesOpen)}
                      className={`flex flex-row items-center justify-between gap-3 px-5 py-2 w-full font-bold text-base font-Poppins
                        ${subSelected ? "border-l-4 border-color3 text-color3 rounded-l-md" : "border-l-0 text-color2"}`}
                    >
                      <div className="flex items-center gap-3">
                        <item.icon size={20} className={subSelected ? "text-color3" : "text-color2"} />
                        <p>{item.label}</p>
                      </div>
                      {relancesOpen ? <FiChevronUp /> : <FiChevronDown />}
                    </button>

                    {relancesOpen && (
                      <div className="flex flex-col ml-8 mt-1 gap-1">
                        {relancesSubMenu.map(sub => {
                          const subIsSelected = isSubMenuActive(sub);
                          return (
                            <button
                              key={sub.label}
                              onClick={() => handleClick(sub.path)}
                              className={`flex flex-row items-center gap-2 px-5 py-1 w-full text-sm rounded-md
                                ${subIsSelected ? "text-color3 font-semibold" : "text-color2 font-medium"}`}
                            >
                              <sub.icon size={16} className={subIsSelected ? "text-color3" : "text-color2"} />
                              <p>{sub.label}</p>
                            </button>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              }

              return (
                <button
                  key={item.label}
                  onClick={() => handleClick(item.path)}
                  className={`flex flex-row items-center gap-4 px-5 py-2 w-full font-bold text-base font-Poppins
                    ${selected ? "border-l-4 border-color3 text-color3 rounded-l-md" : "border-l-0 text-color2"}`}
                >
                  <item.icon size={20} className={selected ? "text-color3" : "text-color2"} />
                  <p>{item.label}</p>
                </button>
              );
            })}
            {/* Support + Logout */}
            <div className="flex flex-col gap-2 ">
              <button
                onClick={handleLogout}
                className="flex flex-row items-center gap-4 px-5 py-2 w-full font-bold text-base font-Poppins border-l-0 text-color2 rounded-l-md"
              >
                <AiOutlineLogout size={20} />
                <p>Se déconnecter</p>
              </button>
            </div>
          </div>
          <div className="flex flex-col items-center  text-center max-w-[180px]  ">
            <Lottie
              animationData={inviterAnimation}
              loop={true}
              className="h-40"
            />
            <p className="text-xs font-medium text-color2 mb-2 ">
              Invitez vos amis et gagnez des avantages !
            </p>
            {/* Bouton animé */}
            <DrawOutlineButton
              onClick={() => navigate(auth?.user ? "/influenceur" : "/influenceur/login")}
              className="mt-2"
            >
              {"Inviter ici !"}
            </DrawOutlineButton>
          </div>



        </div>
      )}
    </div>
  );
};

export default Sidebar;
